import { render, staticRenderFns } from "./add-piano-company.vue?vue&type=template&id=2ec876fa&scoped=true&"
import script from "./add-piano-company.vue?vue&type=script&lang=js&"
export * from "./add-piano-company.vue?vue&type=script&lang=js&"
import style0 from "./add-piano-company.vue?vue&type=style&index=0&id=2ec876fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec876fa",
  null
  
)

export default component.exports